import React from 'react'

const SuccessIcon = ({ className = "success-icon" }) => {
    return (
        <svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.7274 12.7453C20.7274 17.4906 16.8806 21.3374 12.1353 21.3374C7.38997 21.3374 3.54314 17.4906 3.54314 12.7453C3.54314 7.99995 7.38997 4.15313 12.1353 4.15313C16.8806 4.15313 20.7274 7.99995 20.7274 12.7453Z" fill="white" />
            <path d="M12 0.609985C5.3726 0.609985 0 5.98258 0 12.61C0 19.2374 5.3726 24.61 12 24.61C18.6274 24.61 24 19.2374 24 12.61C24 5.98258 18.6274 0.609985 12 0.609985ZM10.157 18.3634L4.67975 12.8861L7.02331 10.5426L10.157 13.6763L16.9767 6.85655L19.3203 9.20011L10.157 18.3634Z" fill="#6EC950" />
        </svg>
    )
}

export default SuccessIcon